var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMovieDirectorIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1180_2369",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1180_2369)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33366 4L8.00033 9.33333H12.0003L9.33366 4H12.0003L14.667 9.33333H18.667L16.0003 4H18.667L21.3337 9.33333H25.3337L22.667 4H26.667C27.4003 4 28.0281 4.26111 28.5503 4.78333C29.0725 5.30556 29.3337 5.93333 29.3337 6.66667V25.3333C29.3337 26.0667 29.0725 26.6944 28.5503 27.2167C28.0281 27.7389 27.4003 28 26.667 28H5.33366C4.60033 28 3.97255 27.7389 3.45033 27.2167C2.9281 26.6944 2.66699 26.0667 2.66699 25.3333V6.66667C2.66699 5.93333 2.9281 5.30556 3.45033 4.78333C3.97255 4.26111 4.60033 4 5.33366 4ZM5.33366 12V25.3333H26.667V12H5.33366ZM10.667 24H21.3337V23.2667C21.3337 22.2889 20.8448 21.5 19.867 20.9C18.8892 20.3 17.6003 20 16.0003 20C14.4003 20 13.1114 20.3 12.1337 20.9C11.1559 21.5 10.667 22.2889 10.667 23.2667V24ZM17.8837 17.8833C18.4059 17.3611 18.667 16.7333 18.667 16C18.667 15.2667 18.4059 14.6389 17.8837 14.1167C17.3614 13.5944 16.7337 13.3333 16.0003 13.3333C15.267 13.3333 14.6392 13.5944 14.117 14.1167C13.5948 14.6389 13.3337 15.2667 13.3337 16C13.3337 16.7333 13.5948 17.3611 14.117 17.8833C14.6392 18.4056 15.267 18.6667 16.0003 18.6667C16.7337 18.6667 17.3614 18.4056 17.8837 17.8833Z",
    fill: "#EAA245"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovieDirectorIcon);
export default __webpack_public_path__ + "static/media/MovieDirectorIcon.bf51426fb863931e2159de5095e75087.svg";
export { ForwardRef as ReactComponent };